import * as React from 'react';
import { DateTime, ValidationProps } from 'ui';
import { parseAsDateUTC, createUTCDate, dateToUTC, createFormatters } from 'app/infrastructure/data/date';
import { CodetableMetadata } from '../../types-store';
import { CodetableTranslation } from '../../constants';
import { getValidationWithoutDuplicates } from 'app/area/codetable/item/code-pickers/helpers';

interface CodeDisabledProps {
  metadata: CodetableMetadata;
  locale: string;
  disabled: Date;
  readOnly?: boolean;
  onChange: (value: Date) => void;
  translation: CodetableTranslation;
  validation?: { [key: string]: ValidationProps };
}

export const CodeDisabled = ({ metadata, validation, locale, disabled, readOnly, onChange, translation }: CodeDisabledProps) => {

  if (!metadata || !metadata.features || !metadata.features.disabled) {
    return null;
  }
  
  const codeDisabledValidation = !!validation && !!validation.disabled ? getValidationWithoutDuplicates(validation.disabled) : undefined;

  return <div className="col-lg-6 col-sm-12">
    <DateTime
      label={translation ? { text: translation.disabled } : undefined}
      useTime={false}
      value={disabled}
      readOnly={readOnly}
      componentId="code_disabled_date_picker"
      className="dateTime"
      parseDate={parseAsDateUTC}
      createDate={createUTCDate}
      cloneDate={dateToUTC}
      locale={locale}
      onChange={onChange}
      captionWrapper={'form'}
      validation={codeDisabledValidation}
      {...createFormatters(locale)}
    />
  </div>;
};
